var exports = {
  "N": "card__2vbPfL",
  "k": "iconCircle__DurkWW",
};

module.exports = exports;
